import type { CartValue } from '@ecomm/data-simplisafe-api'
import * as localStorage from 'local-storage'
import { P, match } from 'ts-pattern'

import { toTotalQuantityInCart } from '../utils/toTotalQuantityInCart'
import type { Cart } from './cartStates'

export type Action =
  | readonly ['no_cart_id']
  | readonly ['not_initialized']
  | readonly ['set_cart_empty']
  | readonly ['set_cart_error', Error]
  | readonly ['set_cart_updating']
  | readonly ['update_cart', CartValue]

export const cartReducer = (cart: Cart, action: Action): Cart => {
  return match(action)
    .with(['update_cart', P.any], ([_, payload]): Cart => {
      const isEmpty = payload.lineItems.length === 0
      const cartQuantity = !payload.isActive
        ? 0
        : toTotalQuantityInCart(payload.lineItems)

      // @TODO: ECP-13288 - Add a test to validate this localStorage.set() call
      localStorage.set('cart_quantity', cartQuantity)

      return !payload.isActive
        ? { _tag: 'not_initialized' }
        : isEmpty
          ? { _tag: 'empty' }
          : {
              _tag: 'with_items',
              val: payload
            }
    })
    .with(
      ['set_cart_updating'],
      ([_]): Cart =>
        match(cart)
          .with(
            { _tag: 'with_items' },
            (c): Cart => ({
              _tag: 'updating',
              val: c.val
            })
          )
          .with(
            { _tag: 'updating' },
            (c): Cart => ({
              _tag: 'updating',
              val: c.val
            })
          )
          .otherwise(() => cart)
    )
    .with(['set_cart_empty'], (): Cart => ({ _tag: 'empty' }))
    .with(
      ['set_cart_error', P.any],
      ([_, payload]): Cart => ({
        _tag: 'error',
        val: payload
      })
    )
    .with(['no_cart_id'], (): Cart => ({ _tag: 'no_cart_id' }))
    .with(['not_initialized'], (): Cart => ({ _tag: 'not_initialized' }))
    .exhaustive()
}
